// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage, ref } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBtRY_ZjsXN0S_T1eBGV_8bN1IU9k4_I6M",
  authDomain: "inmobiliaria-ebf7b.firebaseapp.com",
  projectId: "inmobiliaria-ebf7b",
  storageBucket: "inmobiliaria-ebf7b.appspot.com",
  messagingSenderId: "87601530057",
  appId: "1:87601530057:web:b1799c8b63cc1aff1cb918",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
